import LocalizedStrings from "react-localization";

const localizedStrings = new LocalizedStrings({
  en: {
    navigation: {
      changePassword: "Change Password",
      login: "Login",
      logout: "Logout",
      register: "Register",
      applyToday: "Apply Today",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "Prospective Students",
          applyToday: "Apply Today",
          reqesutInfo: "Request Information",
          admissionTest: "Admission Test",
          interviewSelection: "Interview Selection",
        },
        students: {
          students: "Students",
          profile: "Profile",
          degreePlan: "Degree Plan",
          classes: "Classes",
          schedule: "Schedule",
          attendance: "Attendance",
          grades: "My Final Grades",
          selectClasses: "Select Classes",
          activity: "Activity",
          learningAndManagement: "Learning & Management",
        },
        mystudies: {
          mystudies: "My studies",
          eCAMPUS: "eCAMPUS",
          tutorat: "Tutoring",
          academicorientation: "Academic orientation",
          accessibilityservice: "Education accessibility service",
        },
        mytoolbox: {
          mytoolbox: "My toolbox",
          studentcards: "Student and bus cards",
          parking: "Parking",
          supportservice: "Well-being and mental health support service",
          laboratoryequipmen: "Laboratory equipment",
          groupworkrooms:"Group work rooms",
          
        },
        registration: {
          registration: "Registration",
          collegialeregistration: "Collegiale registration",
          undergraduate1style:
            "Undergraduate university registration (1st cycle)",
          graduateuniversity: "Graduate university registration (2nd cycle)",
        },
        application: {
          application: "Application",
          applicationhome: "Application Home",
        },
        facultyAndStuff: {
          facultyAndStuff: "Faculty & Staff",
          profile: "Profile",
          classes: "Classes",
          enterAttendance: "Enter Attendance",
          testsAndScore: "Tests & Scores",
          learningAndManagement: "Learning & Management",
          attendancereport: "Attendance Report",
        },
        parents: {
          parents: "Parents",
          attendance: "Attendance",
          grades: "Grades",
        },
        alumni: {
          alumni: "Alumni",
          myInfo: "My Information",
          events: "Events",
          opportunities: "Opportunities",
          donations: "Donations",
        },
        events: "Events",
        courseCatalog: "Course Catalog",
        documents: "Documents",
        about: "About",
        applicationhome: "Application Home",
        application: "Application",
        invoices: {
          myfinances: "My Finances",
          invoices: "Invoices",
          invoiceFAQs: "Invoice FAQs",
        },
      },
    },
    footer: {
      students: {
        students: "Students",
        profile: "Profile",
        classes: "Classes",
        attendance: "Attendance",
        schedule: "Schedule",
        grades: "Grades",
      },
      facultyAndStaff: {
        facultyAndStaff: "FACULTY & STAFF",
        profile: "Profile",
        classes: "Classes",
        attendance: "Attendance",
        testsAndScore: "Tests & Score",
        learningManagement: " Learning Management",
      },
      contactUs: {
        contactUs: "CONTACT US",
        email: "Email",
        phone: "Phone",
      },
    },
    login: {
      signIn: "Sign In",
      signInBelowText: "We recommend using a computer rather than a mobile device for the best experience.",
      forgotPassword: " Forgot Password",
      registerMessageOne: "Don't have an account",
      registerMessageTwo: "Create a new Account",
      email: "Email Address",
      password: "Password",
      emailhelpermsg1: "Please include an ’@’ in the email address.",
      emailhelpermsg2: "is missing an ’@’.",
      emailhelpermsg3: ".' is used in the wrong position in",
      notes: "Please note for the admission application:",
      notes1:
        "If you are currently studying at USB, use your account @monusb.ca to submit, continue or verify your application.",
      notes2:
        "If you have started or submitted an application for admission to USB but are not yet registered for classes, enter the email address you used when you initially created your account to continue or to verify your application.",
      notes3:
        "Each person must use their own account to submit an application for admission. It is prohibited to use another person's account to submit an application.",
      notes4:
        "To make changes to the application you submitted or pay the application fees related to it, write to us directly at ",
      notes5: "to follow up.",
    },
    register: {
      register: "Register",
      helpermsg:
        "Please lengthen this text to 2 characters or more (you are currently using 1 character).",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      password: "Password",
      confirmPassword: "Confirm Password",
      signUpMessage: "Already have an account?",
      signIn: "Sign In",
      passwordErrorMsg: "Incorrect confirm password.",
      checkPasswordformat:
        "The password should have at least one upper case letter,one lower case letter,one number and be at least eight characters in length.",
      submityourregistration: "SUBMIT YOUR REGISTRATION",
    },
    forgotPassword: {
      forgotPassword: "Forgot Password",
      email: "Email Address",
      back: "Back",
      submit: "Submit",
    },
    changePassword: {
      confirmoldpassword: "Confirm old password",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm new password",
      submit: "Submit",
      cancel: "Cancel",
    },
    applicationpage: {
      //Page 2
      nameandcitizenshipstatus: "Name & Citizenship Status",
      legalfirstname: "Legal First Name *",
      legalmiddlename: "Legal Middle Name",
      legallastname: "Legal Last Name *",
      preferredname: "Preferred Name",
      birthname: "Maiden/Birth Name",
      formername: "Former Name",
      usbstudent: "Are you a current USB Student? *",
      citizenshipstatus: "Citizenship Status *",
      canadiancitizen: "Canadian Citizen",
      permanentresident: "Permanent Resident",
      refugee: "Refugee",
      nonresidentstudypermit: "Non-resident (study permit)",
      nonresidentworkpermit: "Non-resident (work permit)",
      nonresidentnostudy: "Non-resident (no study permit required)",
      nonresidentstudypermit:
        "Non-resident (study permit – Minnesota reciprocity program)",
      countryofcitizenship: "Country of Citizenship *",
      countryofbirth: "Country of Birth *",
      passport: "Passport *",
      passportno: "Passport No.*",
      passportexiprydate: "Passport Expiry Date *",
      studyandworkpermitno: "Study and Work Permit No.",
      studypermitissuedate: "Study Permit Issue Date",
      studypermitexpirationdate: "Study Permit Expiration Date",
      addresscontactinformation: "Address & Contact Information",
      country: "Country *",
      street: "Street",
      streetapt: "Street/Apt",
      city: "City",
      stateprovince: "State/Province",
      postalcode: "Postal Code",
      email: "Email*",
      emailaddress2: "Email Address 2",
      onlynumerals: "Only numerals",
      otherphone: "Other Phone",
      mobile: "Mobile",
      home: "Home",
      office: "Office",
      homephone: "Primary Phone *",
      optinfortextmessages1:"I accept to receive transactional and promotional SMS messages from the University (to the number indicated above)",
      otherphonenumber: "Other Phone Number",
      canadiancitizen: "Canadian Citizen",
      permanentresident: "Permanent Resident",
      refugee: "Refugee",
      nonresidentstudypermit: "Non-resident (study permit)",
      nonresidentworkpermit: "Non-resident (work permit)",
      nonresidentnostudypermit: "Non-resident (no study permit required)",
      nonresidentstudypermitminnesota:
        "Non-resident (study permit – Minnesota reciprocity program)",
      studyPermitIssueDateError:
        "Date must be greater than Study Permit Issue Date",

      // Page 3
      otherInformation: "Other Information",
      dateOfBirth: "Date of Birth *",
      yearmonthdate: "YYYY/MM/DD",
      gender: "Gender *",
      male: "Male",
      female: "Female",
      iprefernottoanswer: "I prefer not to answer",
      areyouFirstGeneration:
        "Are you First Generation?* Select yes if your Parents/ Guardians never attended a postsecondary institution (College, University)",
      yes: "Yes",
      no: "No",
      nativeLanguage: "Native Language *",
      areyouaVisibleMinority: "Are you a Visible Minority",
      recruitmentAgentsHeader: "Recruitment agents/officers",
      recruitmentAgents:
        "Did you find out about our university through one of our recruitment agents? If yes, select the recruitere from the list.",
      selectaRecruiter: "-- Select a recruiter --",
      canadianIndigenousancestry:
        "Do you want to self-declare your Canadian Indigenous ancestry?",
      answeredyes:
        "If you answered yes, please choose from the following options.",
      firstNations: "First Nations",
      métis: "Métis",
      inuit: "Inuit",
      save: "Save",
      english: "English",
      french: "French",
      frenchenglish: "French & English",
      otherlanguage: "Other Language",
      // Page 4
      program: "Program",
      expectedadmitterm: "Expected Admit Term *",
      programofinterest1: "Program of Interest 1 *",
      programofinterest2: "Program of Interest 2",
      secondProgramChoiceDescription: "Indicating a second program choice is optional. Only if you are not eligible for your first choice will your second choice be evaluated. It is therefore in your best interest to indicate a study program that does not have the same admission requirements as your first choice.",
      admissioncategory: "Admission Category *",
      regular: "Regular",
      mature: "Mature",
      auditing: "Auditing",
      special: "Special",
      senior: "Senior",
      visiting: "Visiting",
      academicadvising: "Academic advising",
      artisticandculturalactivities: "Artistic and cultural activities",
      gymlesportex: "Gym (Le Sportex)",
      intramuralsports: "intramural sports",
      peermentorshipfornewstudents: "Peer mentorship for new students",
      studentaccessibilityservices: "Student accessibility services",
      studentgroupsandassociations: "Student groups and associations",
      studenthousing: "Student housing",
      studentmedia: "Student media (newspaper, radio, social media)",
      supportforwellbeingandmentalhealth:
        "Support for Wellbeing and Mental Health",
      studentactivitiesandstudentservices:
        "Student Activities and Student Services",
      learningmoreabout:
        "Which student services and activities would you be interested in learning more about? Select all that apply:",
      tutoring: "Tutoring (French, English, Spanish)",
      competitivesportsteams:
        "The Competitive sports teams: Les Rouges (basketball, volleyball, soccer, fustal)",
      studenttheatretroupe: "The Student theatre troupe (Les Chiens de soleil)",
      admitterm: "The application period is currently closed. You will be able to start an application in October 2025.",
      // Page 5
      previouseducationhighschool: "Previous Education - High School",
      expecttograduatefromhighschoolmanitoba:
        "Do you expect to graduate from a high school in Manitoba during the current academic year? *",
      provideMETnumber:
        "Provide MET number if you know it (Consult your Manitoba High School if needed ) *",
      lasthighschoolyouattended:
        "Where was the last high school you attended? *",
      lasthighschoolyouattendedlistofschoolsinmanitoba:
        "Select the last high school you attended from the list of schools in Manitoba *",
      lasthighschoolyouattendedfromthelistofschoolsoutsidemanitoba:
        "Select the last high school you attended from the list of schools (outside Manitoba) *",
      lasthighschoolyouattendedfromthelistofschoolsoutsidecanada:
        "Select the last high school you attended from the list of schools (outside Canada) *",
      monthandyeardidyoustartattendingthisschool:
        "In what month and year did you start attending this school? ",
      month: "Month *",
      year: "Year *",
      monthwithoutrequired: "Month",
      yearwithoutrequired: "Year",
      monthandyeardidyoufinishyourstudiesattheschool:
        "In what month and year did you finish your studies at the school?",
      didyougraduate: "Did you graduate? *",
      graduationyear: "Graduation Year *",
      addtionalcoursescomment:"If you would like to provide additional information about your high school education (current or previous), you can write it here:",
      manitoba: "Manitoba",
      canadianprovinceotherthanmanitoba:
        "Canadian Province other than Manitoba",
      outsideofcanada: "Outside of Canada",
      homeschool: "Homeschool",
      finishYearError:
        "The date when the studies were finished cannot be before the date when the studies were started.",
      graduationYearError:
        "The graduation date cannot be before the date when the studies were finished.",

      // Page 6 Translations - English
      previouseducationpostsecondary: "Previous Education - Post Secondary",
      surcettepage:
        "On this page, you must provide a list of universities, colleges, or CEGEPs that you have attended or are currently attending, regardless of the number of courses taken or the dates of these studies. It is important to declare all your current and previous post-secondary studies, whether completed or interrupted, even if they have no relevance to your current application.",
      copieofficielle:
        "An official copy of your final transcript and an attestation of completion (if applicable) must be submitted for each institution attended, except for the University of Manitoba and the Université de Saint-Boniface. It is your responsibility to ensure that the Université de Saint-Boniface receives all documents related to your application before the deadline.",
      inscriptionetablissement:
        "If you register at another institution after submitting this application, you must immediately notify the admissions team at ",
      sansetablissement:
        "If you have not attended a post-secondary institution, you can skip directly to the next page of the application.",
      haveyouappliedusb: "Have you previously applied to USB?*",
      yes: "Yes",
      no: "No",
      mostrecentyear:
        "Which year?* If you have applied more than once, please indicate the most recent year.",
      fournistrenseignements:
        "Provide information on each post-secondary educational institution you have attended (including USB). List the most recent first.",
      educationlevel: "Education Level *",
      schoolname: "School Name",
      startdate: "Start Date",
      enddate: "End Date",
      currentdegreestatus: "Current Degree Status*",
      graduationdate: "Graduation Date",
      deleteschool: "Delete School",
      addschool: "Add a School",
      fournischoolinfo: "Enter the information about the school",
      schoolincanada: "Is the school in Canada?",
      selectschoolcanada:
        "Select the school from the list of Canadian schools*",
      selectschooloutsidecanada:
        "Select the school from the list (outside of Canada)*",
      currentlystudying: "Currently studying",
      graduated: "Graduated",
      nolongerstudying: "No longer studying and did not graduate",
      startmonthyear:
        "In what month and year did you start attending this school?",
      finishmonthyear:
        "In what month and year did you finish your studies at the school?",
      cancelschool: "Cancel School",
      saveschool: "Save School",
      college: "College",
      university: "University",
      cegep: "Cégep",
      // Page 7 Translations English
      header: "Self-Declaration of Grade 12 Marks",
      instructionText:
        "On this page, you can declare your completed and planned Grade 12 course marks for the current academic year.",
      example: "For example: French, 40S, 82",
      instructions: [
        "It is important to declare marks for all Grade 12 courses that you have completed so far.",
        "For courses you are currently taking, you may estimate your marks based on similar Grade 11 course marks or on the grades obtained from tests and assignments in the current course.",
        "Declaring your Grade 12 marks as part of your admission application allows the University of Saint-Boniface to evaluate your application and respond more quickly. If you appear to meet the requirements of the chosen program (with the exception of the Bachelor of Nursing and Nursing Assistant Diploma programs) based on your information, you will receive a conditional offer of admission.",
        "If you choose not to declare your marks, you will not receive an admission decision until early July, when we receive your final transcript.",
      ],
      labels: {
        grade12Courses: "Grade 12 Courses",
        classTitle: "Class Title",
        level: "Level",
        gradewithlabel: "Grade *(nombre entier de 0 à 100)",
        grade: "Grade",
        deleteClass: "Delete Class",
        addClass: "Add Another Class",
        cancelClass: "CANCEL",
        saveClass: "SAVE",
        educationlevel: "Education Level",
        currentdegreestatus: "Current Degree Status",
      },
      classes: {
        advancedMathematics: "Advanced Mathematics",
        appliedMathematics: "Applied Mathematics",
        canadianLaw: "Canadian Law",
        chemistry: "Chemistry",
        cinemaModernHistory: "Cinema - Witness to Modern History",
        computerScience: "Computer Science",
        currentTopics: "Current Topics",
        dance: "Dance",
        dramaticArts: "Dramatic Arts",
        english: "English",
        everydayMathematics: "Everyday Mathematics",
        familyStudies: "Family Studies",
        french: "French (As a 1st language)",
        frenchsecond: "French (As a 2nd language)",
        geography: "Geography",
        globalIssues: "Global Issues",
        guitar: "Guitar",
        harmony: "Harmony",
        history: "History",
        introCalculus: "Introduction to Calculus",
        introCalculusAdvancedMath:
          "Introduction to Calculus and Advanced Mathematics",
        jazz: "Jazz",
        leadershipTraining: "Leadership Training",
        music: "Music",
        biology: "Biology",
        philosophy: "Philosophy",
        physicalEducation: "Physical Education",
        physics: "Physics",
        preCalculusMathematics: "Pre-Calculus Mathematics",
        psychology: "Psychology",
        spanish: "Spanish",
        textileArtsDesign: "Textile Arts and Design",
        visualArts: "Visual Arts",
        workLifeTransition: "Work-life: Transition",
        foodNutrition: "Food and Nutrition",
        other: "Other",
      },

      // Page 8
      paytheapplicationfee: "Pay the Application Fee",
      useacouponcode: "Use a Coupon Code",
      entercouponcode: "Enter Coupon Code",
      applycouponcode: "Apply Coupon Code",
      notavalidcouponcode: "This is not a valid coupon code",
      couponaccepted: "Coupon accepted",

      // Page 9
      payapplicationfee: "Pay Application Fee",
      amountdue: "Amount Due *",
      receiptemail: "Receipt Email *",
      makeapayment: "Make a Payment",
      monerispaymentwasnotsuccessful: "The transaction to Moneris failed. Please try again.",
      monerispaymentwasnotsuccessfultext: "If there is still an issue, send an email to",
      monerispaymentwassuccessful: "Your Moneris Payment was successful",
      yourpayment: "Your payment of",
      hasbeenreceived:
        "has been received. Click the Next button to submit your application.",

      // Application detail
      myapplication: "My Application",
      creationdate: "Creation date",
      applicationprogram: "Program Name",
      yearandterm: "Year and Term",
      submissiondate: "Submission Date",
      deadline: "Deadline",
      status: "Status",
      backpage: "BACK",
      checklist: "Checklist",
      item: "Item",
      notes: "Notes",
      duedate: "Due Date",
      lastupdated: "Last Updated",
      myactionneeded: "My Action Needed",
      pending: "Pending",
      underreview: "Under Review",
      received: "Received",
      waived: "Waived",
      uploaddocument: "Upload Document",
      seenotes: "See Notes",
      none: "None",
      seenotes: "See Notes",
      acceptmyoffer: "Accept my Offer",
      declinemyoffer: "Decline my offer",
      upload: "Upload",
      cancel: "Cancel",
      decisionletters: "Decision Letters",
      decisionText: "You may have difficulty accessing your letter from some mobile devices. For this reason, we advise you to use a computer to view the letter.",

      // Application profile
      nonbinary: "Non-binary",
      termransgender: "Transgender",
      twospirit: "Two-spirit",
      genderother: "Other",
    },
    application: {
      applyToday: "Apply Today",
      back: "Back",
      save: "Save",
      next: "Next",
      esignature: "E-signature *",
      date: "Date *",
      applynow: "APPLY NOW",
      viewprofile: "VIEW AND EDIT PROFILE",
      applicationhome: "Application Home",
      creationdate: "Creation Date",
      program: "Program",
      yearandterm: "Year and Term",
      deadline: "Deadline",
      submissiondate: "Submission Date",
      status: "Status",
      statusdescription: "Status Description",
      submitmyapplication: "Submit My Application",
      otherinfo:
        "The information gathered in this section is used to assess the Université de Saint-Boniface's progress in meeting its commitment to increase the recruitment and retention of Indigenous students. Reporting is voluntary. It could be used to invite you to events or activities for USB's Indigenous community.",
      thanksmsg:
        "Thank you for submitting your application to the Université de Saint-Boniface! A member of the Registrar's Office team will process your request shortly. An automatic email about the next steps will be sent to you within the next 5 minutes to the email address provided in your application. If you have not received it, please check your spam folder. Alternatively, you can contact us at",
      personalInformation: {
        personalInformation: "School, Level, and Student Information",
        firstName: "First Name",
        genderCode: {
          genderCode: "Gender *",
          male: "Male",
          female: "Female",
        },
        governmentid: "ID/Passport Number",
        birthDate: "Date Of Birth* (DD/MM/YYYY)",
        lastName: "Last Name",
        middleName: "Middle Name",
        ses_applicant: "Applicant ID",
        ses_birthcountry: "Country of Birth",
        ses_nationality: "Nationality*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "Programs*",
        },
      },
      statusOptions: {
        started: "Started",
        submitted: "Submitted",
        actionrequired: "Action Required",
        ongoingevaluation: "Ongoing Evaluation",
        conditionaloffer: "Conditional Offer",
        officialacceptance: "Official Acceptance",
        rejected: "Rejected",
        inactive: "Inactive",
        offeraccepted: "Offer Accepted",
        prematriculant:"Pre-Matriculant",
        noShow:"No Show",
        matriculant: "Matriculant",
        student: "Student",
        cancelled: "Cancelled",
        waitlisted: "Waitlisted",
      },
      conatactInformation: {
        conatactInformation: "Contact Information",
        general: {
          general: "General",
          emailaddress1: "Email Address",
          emailaddress2: "Alternate Email Address",
          mobilephone: {
            errorMessage: "Mobile Phone can't be blank",
          },
        },
        homeAddress: {
          homeAddress: "Home Address",
          address1_city: {
            address1_city: "City",
            errorMessage: "City can't be blank",
          },
          address1_country: {
            address1_country: "Country *",
            errorMessage: "Country can't be blank",
          },
          address1_line1: {
            address1_line1: "Street Address",
            errorMessage: "Street Address can't be blank",
          },
          address1_postalcode: "Zip Code/Postal Code",
        },
        legal: {
          legal: "Legal Guardian Information",
          gurd_firstname: {
            gurd_firstname: "First Name",
            errorMessage: "firstname can't be blank",
          },
          gurd_middlename: "Middle Name",
          gurd_lastname: {
            gurd_lastname: "Last Name",
            errorMessage: "lastname can't be blank",
          },
          gurd_birthdate: "Date Of Birth (DD/MM/YYYY)",
          gurd_ses_nationality: "Nationality*",

          gurd_address1_line1: {
            gurd_address1_line1: "Street",
            errorMessage: "Street can't be blank",
          },
          gurd_address1_city: {
            gurd_address1_city: "City",
            errorMessage: "City can't be blank",
          },
          gurd_address1_country: {
            gurd_address1_country: "Country *",
            errorMessage: "Country can't be blank",
          },
          gurd_address1_postalcode: "Zip Code/Postal Code",
          gurd_emailaddress1: {
            gurd_emailaddress1: "Email Address",
            errorMessage: "Email Address can't be blank",
          },
          ses_relationship: {
            ses_relationship: "Relationship with Legal Guardian ",
            father: "Father",
            mother: "Mother",
            guardian: "Guardian",
          },

          gurd_mobilephone: {
            errorMessage: "Mobile Phone Number can't be blank",
          },
        },
        workAddress: {
          workAddress: "Work Address",
          address2_line1: "Street Address",
          address2_city: "City",
          address2_country: "Country *",
          address1_postalcode: "Zip Code/Postal Code",
        },
        mobilePhone: "Mobile Phone",
        homePhone: "Home Phone",
        skypeId: "Skype Id",
      },
      education: {
        education: "Education Information Undergraduate",
        undergraduate: {
          undergraduate: "Secondary School",
          errorMessage: "Secondary School can't be blank",
          ses_country: "Country*",
          ses_graduationyear: "Graduation Year*",
          ses_schoolcontact: {
            ses_schoolcontact: "Faculty",
            errorMessage: "Faculty can't be blank",
          },
          ses_track_value: "Preferred Major*",
          ses_certificateearned: "Other Certificate",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "University",
              errorMessage: "Secondary School can't be blank",
            },
            ses_country: "Country*",
            ses_graduationyear: "Graduation Year*",
            ses_schoolcontact: {
              ses_schoolcontact: "Faculty",
              errorMessage: "Faculty can't be blank",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "Company Name",
              errorMessage: "Company Name can't be blank",
            },
            ses_previousemployment: {
              ses_previousemployment: "Job Title",
              errorMessage: "Job Title can't be blank",
            },
            ses_startdate: "Hiring Date* (DD/MM/YYYY)",
          },
        },
      },
      emergenencyContact: {
        emergenencyContact: "Emergency Contact",
        name: "Name",
        relationship: "Relationship",
        phone: "Emergency Contact Number",
      },
      miscellanous: {
        miscellanous: "Miscellaneous",
        contactMode: "Preferred Method of Contact",
      },
      document: {
        heading: "Application Documents",
        title1: "Document Type",
        title2: "File Name of Uploaded Document",
        types: {
          passport: "Passport",
          transcript: "Transcript",
          photo: "Photo",
          assessment: "Assessment",
          financials: "Financials",
          any: "Any",
        },
      },
    },
    enquiry: {
      save: "Save",
      clear: "Clear",
      testData: "Test Data",
      requestInfo: "Request Information",
      description: `Let us know about you and any questions or comments you might have.
          Please complete the following form and submit it, or send an e-mail to
          admissions@oneworldsis.com.`,
      general: {
        general: "General",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
      },
      conatactInformation: {
        conatactInformation: "Contact Information",
        salutation: "Salutation",
        firstName: "First Name",
        middleName: "Middle Name",
        lastName: "Last Name",
        birthdate: "Birthday",
        mobilePhone: "Mobile Phone",
        telephone1: "Home Phone",
        contactMode: {
          any: "Any",
          email: "Email",
          phone: "phone",
          fax: "Fax",
          mail: "Mail",
        },
        comments: "Enter Comments",
      },
      homeAddress: {
        homeAddress: "Home Address",
        address2_country: "Country *",
        address2_line1: "Street",
        address2_city: "City",
        address2_stateorprovince: "State or Province",
        address2_postalcode: "Zip Code/Postal Code",
      },
      mailingAddress: {
        mailingAddress: "Mailing Address (If Different)",
        address2_country: "Country *",
        address2_line1: "Street",
        address2_city: "City",
        address2_stateorprovince: "State or Province",
        address2_postalcode: "Zip Code/Postal Code",
      },
    },
    students: {
      classes: {
        classes: "Classes",
        refresh: "Refresh",
        table: {
          classId: "Class ID",
          class: "Class",
          course: "Course",
          term: "Term",
          status: "Status",
          classSection: "Class Section",
          credits: "Credits",
          classStatus: "Class Status",
          attendance: "Attendance",
          gradingOption: "Grading Option",
          allTerms: "Terms",
          action: "Action",
          schedule: "Schedule",
          room: "Room",
          rooms: "Rooms",
          continue: "Continue",
          cancel: "Cancel",
          warningcorequisitemsg:
            "If you drop this class, you will also drop all associated co-requisite classes. Would you like to continue?",
          warningmsg:
            "	You are about to drop or withdraw from this course. If you proceed, this action cannot be undone. Would you like to continue?",
        },
        attendance: {
          attendance: "Attendance",
          classDate: "Class Date",
          notes: "Notes",
        },
      },
      selectClasses: {
        next: "Next",
        total: "Total",
        selectClasses: "Select Classes",
        back: "Back",
        submit: "Submit",
        description: "Description",
        errorMessageContent: "You are already enrolled in a class for",
        errorMessageHeader:
          "These are the results of the submission of your class selections. Any issues should be resolved before resubmitting your class selections:",
        checkoutDescription: `Please review your course selection. Click the Submit button to register your class selections. Even if the course status is "Available", your registration will only be confirmed if you meet all the course requirements (prerequisites, etc.). If the class status is "Wait List", you will be added to the wait list for the class.`,
        addNew: "Add New",
        table: {
          term: "Term",
          code: "Code",
          course: "Course",
          description: "Description",
          classStatus: "Class Status",
          credits: "Credits",
          gradeOption: "Grade Option",
          classNotes: "Class Notes",
          price: "Price",
          action: "Action",
          corequisitemsg: "is a co-requisite of",
          warningtimeconflict: "has a schedule conflict with a class in which you are already enrolled.",
          multipleTimeConflict: "There is a schedule conflict between",
          notenrolled: "You have not been enrolled in the class.",
          enrolled: "You have been enrolled in the class.",
          and: "and",
          message: "This class is already in your list. Please remove it before adding again.",
        },
        modalTable: {
          courseCataLog: "Course Catalog",
          term: "Term",
          allTerms: "Terms",
          allSchools: "Schools",
          department: "Department",
          allDepartments: "Departments",
          course: "Course",
          allCourses: "Courses",
          campus: "Campus",
          allCampuses: "Campuses",
          faculty: "Instructor(s)",
          schedule: "Schedule",
          firstClassMeeting: "First Class Meeting",
          classNotes: "Class Notes",
          classStatus: "Class Status",
          credits: "Credits",
          enrolled: "Enrolled / Availability",
          firstMeet: "First Meeting",
          price: "Price",
          actions: "Actions",
          close: "Close",
          add: "Add",
          classDates: "Class Dates",
          classDate: "Class Date",
          endDate: "End Date",
          startDate: "Start Date",
          class: "Class ID",
          credits: "Credits",
          rooms: "Rooms",
          room: "Room",
          allcourseLevel: "Course Levels",
          courselevel: "Course Level",
          schoolname: "School",
          availableclasses: "Available classes",
        },
      },
      profile: {
        save: "Save",
        refresh: "Refresh",
        back: "Back",
        heading: "My Profile",
        info: `Any field with an * is required before the "Save" button becomes active.`,
        primaryDetails: {
          primaryDetails: "Personal Information",
          emailaddress1: "Email Address",
          firstName: "First Name",
          preferredname:"Preferred name",
          middleName: "Middle Name",
          lastName: "Last Name",
          suffix: "Suffix",
          birthdate: "Birthday",
          gender: "Gender",
          studentid: "Student ID",
          usb_univofmanitobastudentid:"University of Manitoba Student ID",
          applicantId: "Applicant ID",
          governmentid: "Social Insurance Number (SIN)",
          genderCode: {
            male: "Male",
            female: "Female",
          },
        },
        contact: {
          contact: "Contact Information",
          mobilePhone: "Mobile Phone",
          telephone1: "Home Phone",
          telephone2: "Home",
          business2: "Office",
          skypeId: "Skype ID",
          prospectivetelephone1: "Home Phone",
          optinfortextmessages:
            "I accept to receive transactional and promotional SMS messages from the University (to the number indicated above).",
        },
        HomeAddress: {
          HomeAddress: "Address",
          address1_country: "Country *",
          address1_line1: "Street",
          address1_city: "City",
          address1_stateorprovince: "State or Province",
          address1_postalcode: "Zip Code/Postal Code",
          prospective_address1_postalcode: "Zip Code/Postal Code",
        },
        mailingAddress: {
          mailingAddress: "Mailing Address (If Different)",
          address2_country: "Country *",
          address2_line1: "Street",
          address2_city: "City",
          address2_stateorprovince: "State or Province",
          address2_postalcode: "Zip Code/Postal Code",
        },
        billingAddress: {
          billingAddress: "Billing Address (if different than mailing)",
          address3_country: "Country",
          address3_line1: "Street",
          address3_city: "City",
          address3_stateorprovince: "State or Province",
          address3_postalcode: "Zip Code/Postal Code",
        },
        emergenencyContact: {
          emergenencyContact: "Emergency Contact",
          name: "Name",
          relationship: "Relationship",
          phone: "Emergency Contact Number",
        },
      },
      degreePlan: {
        canviewegreeplan:
          "Your Progress Report cannot be viewed at this time. Please note that academic program progress reports are under development and will be posted here in 2025.",
        requireddegreecourses: "Required Degree Courses",
        degreecoursegroups: "Degree Course Groups",
        myDegreePlan: "My Degree Plan",
        programDescription: "Program Description",
        grade: "Grade",
        status: "Status",
        creditsearned: "Credits Earned",
        creditstype: "Credit Type",
        creditsavailable: "Credits Available",
        order: "Order",
        coursename: "Course Name",
        course: "Course",
        degreePlan: "Degree Plan",
        creditsrequired: "Credits Required",
        earnedCredits: "Earned Credits",
        transferCredits: "Transfer Credits",
        completed: "Completed",
      },
      grades: {
        grades: "My Final Grades",
        class: "Class",
        classId: "Class ID",
        classstatus: "Class Status",
        allterms: "All Terms",
        gradingoption: "Grading option",
        creditsearned: "Credits Earned",
        course: "Course",
        credits: "Credits",
        status: "Status",
        grade: "Grade",
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "Save",
        heading: "Enter Attendance",
        selectOne: "Select One",
        term: "Term",
        className: "Class Name",
        NoClassNameMsg: "No class are available for the specified term",
        classDates: "Class Dates",
        noClassDatesMsg:
          "There are no class dates available for entering attendance.",
        attendancereport: "Attendance Report",
        studentid: "Student ID",
        table: {
          studentName: "Student Name",
          institutionIdNo: "Institution ID Number",
          present: "Present",
          tardy: "Tardy",
          unexcusedAbsent: "Unexcused Absent",
          excusedAbsent: "Excused Absent",
          remarks: "Remarks",
        },
      },
      testScore: {
        subject: "Subject",
      },
      class: {
        gradeoption: "Grade Option",
        credits: "Credits",
        classname: "Class Name",
        class: "Class",
        status: "Status",
      },
    },
    account: {
      unpaidinvoices: "Invoices",
      payments: "Payments",
      date: "Date",
      type: "Type",
      invoicenumber: "Invoice Number",
      term: "Term",
      viewreceipt: "View Receipt",
      paiddate: "Paid Date",
      amount: "Amount",
      status: "Status",
      invoice: "Invoice",
      totalamount: "Total Amount",
      total: "Total Amount Owed",
      amountpaid: "Amount Paid",
      amountremaining: "Amount Remaining",
      viewinvoice: "View Invoice",
      paymentno: "NO. DE PAIEMENT",
      notes: "Notes",
      accountsummary: "Account Summary",
    },
    documents: {
      availableuntil: "Available Until",
      subject: "Subject",
      filename: "Filename",
    },
    courseCataLog: {
      heading: "Course Catalog",
    },
    homePage: {
      about: {
        about: "About OneWorldSIS Global University",
        desciption:
          "OneWorld Global University was founded to provide the most comprehensive curriculum focused on teaching the core principles of true digital transformation. This program will equip students to assist organizations in developing and implementing digital transformation technology that will allow institutions to achieve their optimal efficiencies and enhance the day to day lives of their constituents.",
      },
      focus: {
        heading: "Our Core Values",
        collegiality: "Collegiality",
        inclusivity: "Inclusivity",
        excellence: "Excellence",
        innovation: "Innovation",
      },
      gallery: {
        studentProfile: "Student Profile",
        classes: "Classes",
        admission: "Admission",
      },
      newsLetter: {
        heading: "Subscribe to our Newsletter for latest news.",
        subscribe: "Subscribe",
        email: "Your-Email",
      },
    },
    rows: {
      rowsperpage: "Rows per page:",
    },
    general: {
      pagenotfound: "Oops! Nothing was found",
      pagenotavailable:
        "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
      returntohome: "Return to homepage",
      validInput: "Please provide valid input for all the required field",
      notestsavailable: "There are no tests associated with this class",
      passwordhaslowercase: "Your password requires a lower case letter",
      passwordhasuppercase: "Your password requires an upper case letter",
      passwordnumber: "Your password requires a number",
      passwordlengthmax: "Your password length should be max 25 digits",
      confirmpassword: "Password and confirm Password do not match",
      passwordnotmatch: "Passwords do not match",
      passwordcontains:
        "Password must  contain at least one numeric digit, one uppercase and one lowercase letter and at least 8  characters",
      invalidemail: "Invalid Email Address",
      invalidname: "The name can only include alphabetic letters, spaces, hyphens, or apostrophes. And, the name must begin with a capital letter.",
      invalidfirstname: "The legal first name must begin with a capital letter and may include only alphabetic letters, spaces, hyphens, or apostrophes.",
      invalidlastname: "The legal last name must begin with a capital letter and may include only alphabetic letters, spaces, hyphens, or apostrophes.",
      invalidmiddlename: "Other legal given names must begin with a capital letter and may include only alphabetic letters, spaces, hyphens, or apostrophes.",
      invalidpreferredname: "The preferred name can only include alphabetic letters, spaces, hyphens, or apostrophes. And, the name must begin with a capital letter.",
      invalidmaidenname: "The maiden/birth name can only include alphabetic letters, spaces, hyphens, or apostrophes. And, the name must begin with a capital letter.",
      invalidformername: "The former name can only include alphabetic letters, spaces, hyphens, or apostrophes. And, the name must begin with a capital letter.",
      invalidnamemsg: "can only include alphabetic letters, spaces, hyphens, or apostrophes. And, the name must begin with a capital letter.",
      loginerrorMessage: "Invalid Username or Password",
      classerrorMessage: "No data found!",
      documentserrorMessage: "Error No documents Found",
      saveAttedancemessage: "Attendance updated",
      somethingwentwrong: "Something Went Wrong",
      noattendanceMessage: "No attendance record available",
      success: "Success",
      successfullycreatedmsg: "successfully created",
      passwordsuccessmsg: "Password successfully changed",
      dataupdatedMessage: "Data Updated",
      fileuploadMessage: "File Uploaded",
      studentiderrorMessage: "student id is required",
      classiderrorMessage: "class id is required",
      testiderrorMessage: "Test id is required",
      invalidstudentMessage: "Invalid student",
      invalidfiletypeMessage:
        "Only Document type pdf/doc/docx/jpg/xlsx allowed",
      userexistserrorMessage:
        "User Already Exists,try login with your email Id",
      registrationcompletedMessage: "You have been enrolled in the class.",
      coursenotmeterrorMessage:
        "The student cannot be enrolled because all of the prerequisites for the course have not been met.",
      invalidToken: "Invalid token",
      invalidTokenandheader: "Invalid token or you are missing header token",
      invalidRequest: "Invalid request",
      invalidcurrentpassword: "Invalid current password",
      resetemailmsg: "A password reset email should be waiting in your inbox",
      sessionexpired: "Session Expired",
      validinput: "Provide validate input",
      savegradesmsg:
        "You are able to save grades which exceed the maximum points possible. Continue?",
      errornoclassdata: "Error No class Data Found",
      of: "of",
      month: "Month",
      week: "Week",
      day: "Day",
      next: "Next",
      back: "Back",
      today: "Today",
      agenda: "Agenda",
      weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      year: [
        `January`,
        `February`,
        `March`,
        `April`,
        `May`,
        `June`,
        `July`,
        `August`,
        `September`,
        `October`,
        `November`,
        `December`,
      ],
      classStatusAvailable: "Available",
      classStatusFull: "Full",
      classStatusWaitList: "Wait List",
      classStatusCancelled: "Cancelled",
      classStatusClosed: "Closed",
      classStatusCompleted: "Completed",
      StatusWaitList: "Wait list",
      StatusEnrolled: "Enrolled",
      StatusCompleted: "Completed",
      StatusCancelled: "Cancelled",
      StatusIncomplete: "Incomplete",
      StatusDropped: "Dropped",
      StatusTentative: "Tentative",
      StatusTransfer: "Transfer",
      StatusWithdraw: "Required to Withdraw",
      StatusWithdrawal: "Withdrawal",
      paymentCash: "Cash",
      paymentCheck: "Check",
      paymentCredit: "Credit",
      paymentDebit: "Debit",
      paymentOnline: "Online",
      paymentGlobalPay: "GlobalPay",
      paymentWire: "Wire",
      paymentAward: "Award",
      paymentElectronicrefund: "Electronic refund",
      paymentRefundbybanktransfer: "Refund by bank transfer",
      reimbursement: "Reimbursement",
      reimbursementeft: "Reimbursement",
      reimbursementwire: "Reimbursement",
      reimbursementcc: "Reimbursement",
      profileMale: "Male",
      profileFemale: "Female",
      profileNotSpecified: "Not specified",
      profileUndisclosed: "Undisclosed",
      profileNonbinary: "Non binary",
      profileAgender: "Agender",
      selectClassGrade: "Grade",
      selectClassPassFail: "Pass/Fail",
      selectClassAudit: "Audit",
      selectClassAward: "Award",
      profileSINErrorMsg: "Please enter a valid Social Insurance Number (SIN).",
      courseCatalogHeading:
        "If class status is Closed, registration is no longer open.",
      courseCatalogInformation:
        "Hover over Term and Class to see additional information.",
    },
  },
  fr: {
    general: {
      pagenotfound: "Oups! Rien n'a été trouvé",
      pagenotavailable:
        "La page que vous recherchez a peut-être été supprimée, son nom a changé ou elle est temporairement indisponible.",
      returntohome: "Retour à la page d'acceuil",
      validInput:
        "Veuillez fournir des données valides pour tous les champs requis",
      notestsavailable: "Aucun test n'est associé à cette classe",
      passwordhaslowercase:
        "Votre mot de passe a besoin d'une lettre minuscule",
      passwordhasuppercase:
        "Votre mot de passe a besoin d'une lettre majuscule",
      passwordnumber: "Votre mot de passe a besoin d'un numéro",
      passwordlengthmax:
        "Votre mot de passe doit être composé de 25 chiffres au maximum.",
      confirmpassword:
        "Mot de passe initial et la confirmation du mot de passe ne correspond pas",
      passwordnotmatch: "Les mots de passe ne correspondent pas",
      passwordcontains:
        "Le mot de passe doit contenir au moins un chiffre, une lettre majuscule et une lettre minuscule et au moins 8 caractères",
      invalidemail: "Adresse courriel non valide",
      invalidname: "Le nom doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidfirstname: "Le prénom légal doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidlastname: "Le nom légal doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidmiddlename: "Les autres prénoms légaux doivent commencer par une majuscule et ne peuvent inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidpreferredname: "Le prénom choisi doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidmaidenname: "Le nom de naissance doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidformername: "L'ancien nom doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      invalidnamemsg: "doit commencer par une majuscule et ne peut inclure que des lettres alphabétiques, des espaces, des traits d'union ou des apostrophes.",
      loginerrorMessage: "Nom d'utilisateur ou mot de passe invalide",
      classerrorMessage: "Aucune donnée trouvée",
      documentserrorMessage: "Erreur Aucun document trouvé",
      saveAttedancemessage: "Mise à jour des présences",
      somethingwentwrong: "Il y a eu un problème",
      noattendanceMessage: "Aucune fiche de présence disponible",
      success: "Succès",
      successfullycreatedmsg: "Créé avec succès",
      passwordsuccessmsg: "Mot de passe modifié avec succès",
      dataupdatedMessage: "Données mises à jour",
      fileuploadMessage: "Fichier téléchargé",
      studentiderrorMessage: "Le numéro de l'étudiant est requis",
      classiderrorMessage: "Le numéro de la classe est requis",
      testiderrorMessage: "Le numéro du test est requis",
      invalidstudentMessage: "Étudiant non valide",
      invalidfiletypeMessage:
        "Seuls les documents type pdf/doc/docx/jpg/xlsx sont autorisés",
      userexistserrorMessage:
        "L'utilisateur existe déjà, essayez de vous connecter avec votre e-mail",
      registrationcompletedMessage: "Vous avez été inscrit à ce cours.",
      coursenotmeterrorMessage:
        "L'étudiant ne peut pas s'inscrire car tous les préalables pour ce cours ne sont pas remplis",
      invalidToken: "Jeton invalide",
      invalidTokenandheader: "Jeton invalide ou jeton d'en-tête manquant",
      invalidRequest: "Requête non valide",
      invalidcurrentpassword: "Mot de passe actuel invalide",
      resetemailmsg:
        "Un e-mail de réinitialisation de mot de passe devrait vous attendre dans votre boîte de réception",
      sessionexpired: "Session expirée",
      validinput: "Fournir des données validées",
      savegradesmsg:
        "Vous pouvez sauvegarder les notes qui dépassent le maximum de points possible. Poursuivre ?",
      errornoclassdata: "Erreur aucune donnée de cours n'a été trouvée",
      of: "de",
      month: "Mois",
      week: "Semaine",
      day: "Jour",
      next: "Suivant",
      back: "Précédent",
      today: "Aujourd'hui",
      agenda: "Ordre du jour",
      weekdays: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
      year: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      classStatusAvailable: "Disponible",
      classStatusFull: "Complet",
      classStatusWaitList: "Liste d'attente",
      classStatusCancelled: "Annulé",
      classStatusClosed: "Fermé",
      classStatusCompleted: "Terminé",
      StatusWaitList: "Liste d'attente",
      StatusEnrolled: "Inscrit",
      StatusCompleted: "Terminé",
      StatusCancelled: "Annulé",
      StatusIncomplete: "Incomplet",
      StatusDropped: "Abandonné",
      StatusTentative: "Provisoire",
      StatusTransfer: "Transfert",
      StatusWithdraw: "Obligation de se retirer",
      StatusWithdrawal: "Retrait",
      paymentCash: "Comptant",
      paymentCheck: "Chèque",
      paymentCredit: "Crédit",
      paymentDebit: "Débit",
      paymentOnline: "En ligne",
      paymentGlobalPay: "GlobalPay",
      paymentWire: "Virement",
      paymentAward: "Bourse",
      paymentElectronicrefund: "Remboursement électronique",
      paymentRefundbybanktransfer: "Remboursement par virement bancaire",
      reimbursement: "Remboursement",
      reimbursementeft: "Remboursement par virement bancaire",
      reimbursementwire: "Remboursement électronique",
      reimbursementcc: "Remboursement par carte de crédit",
      profileMale: "Homme",
      profileFemale: "Femme",
      profileNotSpecified: "Non spécifié(e)",
      profileUndisclosed: "Non divulgué(e)",
      profileNonbinary: "Non binaire",
      profileAgender: "Sans genre",
      selectClassGrade: "Note",
      selectClassPassFail: "Réussite/Echec",
      selectClassAudit: "Audit",
      selectClassAward: "Bourse",
      profileSINErrorMsg:
        "Veuillez saisir un numéro d'assurance sociale (NAS) valide.",
      courseCatalogHeading:
        "Si le statut du cours est Fermé, l'inscription n'est plus ouverte.",
      courseCatalogInformation:
        "Placez le curseur sur la session et sur le cours pour voir plus de renseignements.",
    },

    navigation: {
      changePassword: "Changer le mot de passe",
      login: "Se connecter",
      logout: "Se déconnecter",
      register: "S'inscrire",
      applyToday: "Faire une demande d'admission",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "Futurs étudiants",
          applyToday: "Faire une demande d'admission",
          reqesutInfo: "Demande d'information",
          admissionTest: "Test d'admission",
          interviewSelection: "Sélection d'entrevue",
        },
        students: {
          students: "Étudiants",
          profile: "Mon profil",
          degreePlan: "Mon rapport de cheminement",
          classes: "Mes cours",
          schedule: "Mon horaire",
          attendance: "Présence",
          grades: "Mes notes finales",
          selectClasses: "Choisir des cours",
          activity: "Activité",
          learningAndManagement: "Gestion de l'apprentissage",
        },
        mystudies: {
          mystudies: "Mes études",
          eCAMPUS: "eCAMPUS",
          tutorat: "Tutorat",
          academicorientation: "Orientation académique",
          accessibilityservice: "Service d’accessibilité aux études",
        },
        mytoolbox: {
          mytoolbox: "Ma boîte à outils",
          studentcards: "Cartes étudiantes et d’autobus",
          parking: "Stationnement",
          supportservice:
            "Service de soutien au bienêtre et à la santé mentale",
          laboratoryequipmen: "Matériel de laboratoire",
          groupworkrooms:"Salles de travail de groupe"
        },
        registration: {
          registration: "Inscription",
          collegialeregistration: "Inscription collégiale",
          undergraduate1style: "Inscription universitaire (1er cycle)",
          graduateuniversity: "Inscription universitaire (2e cycle)",
        },
        application: {
          application: "Application",
          applicationhome: "Application Home",
        },
        facultyAndStuff: {
          facultyAndStuff: "Professeurs et personnel",
          profile: "Mon profil",
          classes: "Mes cours",
          enterAttendance: "Feuille de présences",
          testsAndScore: "Évaluations et résultats",
          learningAndManagement: "Gestion de l'apprentissage",
          attendancereport: "Rapport de présence",
        },
        parents: {
          parents: "Parents",
          attendance: "Présence",
          grades: "Notes",
        },
        alumni: {
          alumni: "Diplômés",
          myInfo: "Mes renseignements",
          events: "Évènements",
          opportunities: "Opportunités",
          donations: "Dons",
        },
        events: "Évènements",
        courseCatalog: "Catalogue de cours",
        documents: "Documents",
        about: "À propos",
        application: "Admission",
        applicationhome: "Demande d’admission",
        invoices: {
          myfinances: "Mes finances",
          invoices: "Factures",
          invoiceFAQs: "FAQ sur la facture",
        },
      },
    },
    footer: {
      students: {
        students: "Étudiants",
        profile: "Mon profil",
        classes: "Mes cours",
        attendance: "Présence",
        schedule: "Emploi du temps",
        grades: "Notes",
      },
      facultyAndStaff: {
        facultyAndStuff: "Professeurs et personnel",
        profile: "Mon profil",
        classes: "Mes cours",
        attendance: "Présence",
        testsAndScore: "Évaluations et résultats",
        learningAndManagement: "Gestion de l'apprentissage",
      },
      contactUs: {
        contactUs: "Contactez-nous",
        email: "Courriel",
        phone: "Téléphone",
      },
    },
    login: {
      signIn: "Se connecter",
      signInBelowText: "Nous recommandons d'utiliser un ordinateur plutôt qu'un appareil mobile pour obtenir une expérience optimale.",
      forgotPassword: "Mot de passe oublié",
      registerMessageOne: "Je n'ai pas de compte",
      registerMessageTwo: "Créer un nouveau compte",
      email: "Courriel",
      password: "Mot de passe",
      emailhelpermsg1: "Le courriel doit contenir un « @ ».",
      emailhelpermsg2: "Il manque un « @ »  à l’adresse :",
      emailhelpermsg3:
        "Il y a un problème lié à l’emplacement du « . » dans l’adresse :",
      notes: "À noter pour la demande d’admission:",
      notes1:
        "Si tu es présentement aux études à l’USB, utilise ton compte @monusb.ca pour soumettre, continuer ou vérifier ta demande.",
      notes2:
        "Si tu as commencé ou soumis une demande d’admission à l’USB mais tu n’es pas encore inscrit à des cours, entre l’adresse courriel que tu as utilisée quand tu as initialement créé ton compte pour continuer ou pour vérifier ta demande.",
      notes3:
        "Chaque personne doit utiliser son propre compte pour soumettre une demande d’admission. Il est interdit de se servir du compte d’une autre personne pour soumettre une demande.",
      notes4:
        "Pour effectuer des changements à la demande que tu as soumise ou payer les frais de traitement de dossier liés à celle-ci, écris-nous directement à ",
      notes5: "pour faire ces suivis.",
    },
    register: {
      register: "Créer un nouveau compte",
      helpermsg:
        "Ce texte doit être de 2 caractères ou plus (il y a actuellement 1 caractère).",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Courriel",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      signUpMessage: "J’ai déjà un compte.",
      signIn: "Se connecter",
      passwordErrorMsg: "Les mots de passe ne correspondent pas",
      checkPasswordformat:
        "Le mot de passe doit comporter au moins huit caractères, y compris une lettre majuscule, une lettre minuscule et un chiffre.",
      emailErrorMsg: "Courriel invalide",
      submityourregistration: "CRÉER MON COMPTE",
    },
    forgotPassword: {
      forgotPassword: "Mot de passe oublié",
      email: "Entrez votre adresse courriel",
      back: "Page précédente",
      submit: "Soumettre",
      emailErrorMsg: "Courriel invalide",
    },
    changePassword: {
      confirmoldpassword: "Entrer l'ancien mot de passe",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: " Confirmer le nouveau mot de passe",
      submit: "Soumettre",
      cancel: "Annuler",
    },
    applicationpage: {
      // Page 2
      nameandcitizenshipstatus: "Nom et statut de citoyenneté",
      legalfirstname: "Prénom légal *",
      legalmiddlename: "Autres prénoms légaux",
      legallastname: "Nom légal *",
      preferredname: "Prénom choisi",
      birthname: "Nom de naissance",
      formername: "Ancien nom",
      usbstudent: "Poursuis-tu actuellement des études à l'USB? *",
      citizenshipstatus: "Statut de citoyenneté *",
      canadiancitizen: "Citoyen canadien",
      permanentresident: "Résident permanent",
      refugee: "Refugié",
      nonresidentstudypermit: "Non-résident (permis d’études requis)",
      nonresidentworkpermit: "Non-résident (permis de travail requis)",
      nonresidentnostudy: "Non-résident (permis d’études non requis)",
      nonresidentstudypermit:
        "Non-résident (permis d’études requis  – programme de réciprocité Minnesota-Manitoba) Country of Citizenship = Pays de citoyenneté",
      countryofcitizenship: "Pays de citoyenneté *",
      countryofbirth: "Pays de naissance *",
      passportno: "Numéro de passeport *",
      passport: "Passeport *",
      passportexiprydate: "Date d'expiration du passeport *",
      studyandworkpermitno: "Numéro de permis d'études ou de travail",
      studypermitissuedate:
        "Date de délivrance du permis d'études ou de travail",
      studypermitexpirationdate:
        "Date d'expiration du permis d'études ou de travail",
      addresscontactinformation: "Adresse et coordonnées",
      country: "Pays *",
      street:
        "Adresse",
      streetexp:"numéro et nom de rue, case postale, appartement, unité, étage, etc.",
      streetapt: "Adresse (continuation)",
      city: "Ville",
      stateprovince: "Province ou état",
      postalcode: "Code postal",
      email: "Adresse courriel *",
      emailaddress2: "Adresse courriel secondaire",
      onlynumerals: "(chiffres seulement; aucun caractère spécial)",
      otherphone: "Autre type de téléphone",
      mobile: "Téléphone cellulaire",
      home: "Téléphone à domicile",
      office: "Téléphone au travail",
      homephone: "Téléphone principal*",
      optinfortextmessages1:"J'accepte de recevoir des messages transactionnels et promotionnels de l'Université par SMS (au numéro indiqué ci-dessus).",
      otherphonenumber: "Autre type de téléphone",
      canadiancitizen: "Citoyen canadien",
      permanentresident: "Résident permanent",
      refugee: "Refugié",
      nonresidentstudypermit: "Non-résident (permis d’études requis)",
      nonresidentworkpermit: "Non-résident (permis de travail requis)",
      nonresidentnostudypermit: "Non-résident (permis d’études non requis)",
      nonresidentstudypermitminnesota:
        "Non-résident (permis d’études requis  – programme de réciprocité Minnesota-Manitoba)",
      studyPermitIssueDateError:
        "Cette date doit être après la date de délivrance du permis d'études ou de travail",
      // Page 3
      otherInformation: "Informations additionnelles",
      dateOfBirth: "Date de naissance *",
      yearmonthdate: "AAAA/MM/JJ",
      gender: "Genre *",
      male: "Homme",
      female: "Femme",
      iprefernottoanswer: "Je préfère ne pas répondre",
      areyouFirstGeneration:
        "Es-tu étudiant·e de première génération?* Réponds « Oui » si tes parents/tuteurs légaux n’ont jamais fréquenté un établissement postsecondaire (collège, université).",
      yes: "Oui",
      no: "Non",
      nativeLanguage: "Quelle est ta langue maternelle? *",
      areyouaVisibleMinority:
        "Es-tu membre d’un groupe sous-représenté ou d’une minorité visible?",
      recruitmentAgentsHeader: "Agents de recrutement",
      recruitmentAgents:
        "As-tu entendu parler de notre université par l'intermédiaire d'un de nos agents de recrutement? Si oui, sélectionne le nom de l'agent dans la liste.",
      selectaRecruiter: "Sélectionner",
      canadianIndigenousancestry:
        "Veux-tu déclarer ton ascendance autochtone du Canada?",
      answeredyes: "Sélectionner parmi les options suivantes :",
      firstNations: "Premières Nations",
      métis: "Métis",
      inuit: "Inuit",
      save: "Enregistrer",
      english: "Anglais",
      french: "Français",
      frenchenglish: "Français et anglais",
      otherlanguage: "Autre langue",

      // Page 4
      program: "Programme d’études",
      expectedadmitterm: "Pour quelle session souhaites-tu faire demande? *",
      programofinterest1: "Programme d’études – premier choix *",
      programofinterest2: "Programme d'études – deuxième choix  (facultatif)",
      secondProgramChoiceDescription: "L'indication d'un deuxième choix de programme d'études est facultative. Ce n'est que si tu n'es pas admissible à ton premier choix que l'évaluation pour ton deuxième choix aura lieu. Il est donc dans ton intérêt d'indiquer un programme d'études qui n'a pas les mêmes exigences d'admission que ton premier choix.",
      admissioncategory: "Catégorie d'admission *",
      regular: "Population régulière",
      mature: "Population adulte",
      auditing: "Population auditrice libre",
      special: "Population spéciale",
      senior: "Population du troisième âge",
      visiting: "Population en visite",
      academicadvising: "Service d’orientation pédagogique",
      artisticandculturalactivities: "Activités artistiques et culturelles",
      gymlesportex: "Centre de conditionnement physique (Le Sportex)",
      intramuralsports: "Sports intramuros",
      peermentorshipfornewstudents:
        "Mentorat pour nouveaux membres de la population étudiante",
      studentaccessibilityservices: "Service d’accessibilité aux études",
      studentgroupsandassociations: "Associations et groupes étudiants",
      studenthousing: "Logement étudiant",
      studentmedia: "Médias étudiants (journal, radio, réseaux sociaux)",
      supportforwellbeingandmentalhealth:
        "Service de soutien au bienêtre et à la santé mentale",
      studentactivitiesandstudentservices:
        "Activités et services destinés à la population étudiante",
      tutoring: "Centre de tutorat (français, anglais, espagnol)",
      competitivesportsteams:
        "Équipes sportives compétitives Les Rouges (basketball, volleyball, soccer, futsal)",
      studenttheatretroupe: "Théâtre étudiant (Les Chiens de soleil)",
      admitterm: "La période d'admission pour l'année 2026-2027 est maintenant terminée. S'il te plait, revenir vers le début octobre pour déposer une demande à la session d'automne 2027.",
      learningmoreabout:
        "Sur quels activités et services destinés à la population étudiante souhaites-tu en savoir plus? Sélectionne toutes les options qui s’appliquent.",

      // Page 5
      previouseducationhighschool:
        "Études actuelles ou antérieures – École secondaire",
      expecttograduatefromhighschoolmanitoba:
        "Prévois-tu d’obtenir ton diplôme d’une école secondaire du Manitoba au cours de l’année scolaire actuelle? *",
      provideMETnumber:
        "Quel est ton numéro MET (Manitoba Education and Training number)? Ce numéro à 9 chiffres apparait sur chacun de tes relevés de notes ou bulletins du système scolaire manitobain. *",
      lasthighschoolyouattended: "Où se situe ton école secondaire? *",
      lasthighschoolyouattendedlistofschoolsinmanitoba:
        "Sélectionne ton école secondaire de la liste d’écoles du Manitoba.*",
      lasthighschoolyouattendedfromthelistofschoolsoutsidemanitoba:
        "Sélectionne ton école secondaire de la liste d’écoles canadiennes située en dehors du Manitoba. *",
      lasthighschoolyouattendedfromthelistofschoolsoutsidecanada:
        "Sélectionne ton école secondaire de la liste d’écoles en dehors Canada. *",
      monthandyeardidyoustartattendingthisschool:
        "Indique le mois et l’année où tu as commencé de fréquenter cet établissement.",
      month: "Mois *",
      year: "Année *",
      monthwithoutrequired: "Mois",
      yearwithoutrequired: "Année",
      monthandyeardidyoufinishyourstudiesattheschool:
        " Indique le mois et l’année où tu as terminé ou prévois terminer tes études à cet établissement.",
      didyougraduate: "As-tu obtenu ton diplôme de cette école? *",
      graduationyear: "Année d’obtention du diplôme *",
      addtionalcoursescomment:'Si tu souhaites fournir des explications supplémentaires en lien avec tes études d’école secondaire (actuelles ou antérieures), tu peux les écrire ici :',
      manitoba: "Manitoba",
      canadianprovinceotherthanmanitoba:
        "Province canadienne autre que le Manitoba",
      outsideofcanada: "En dehors du Canada",
      homeschool: "L'enseignement à domicile",
      finishYearError:
        "La date de fin des études ne peut être antérieure à la date de début des études.",
      graduationYearError:
        "La date d'obtention du diplôme ne peut être antérieure à la date de fin des études.",

      // Page 6 Translations - French
      previouseducationpostsecondary:
        "Études actuelles ou antérieures – Études postsecondaires",
      surcettepage:
        "Sur cette page, il faut fournir une liste des universités, des collèges ou des cégeps que tu as fréquentés ou que tu fréquentes présentement, peu importe le nombre de cours suivis ou les dates de ces études. Il est important de déclarer toutes tes études postsecondaires actuelles et antérieures, terminées ou interrompues, même si elles n’ont aucun lien avec ta demande actuelle.",
      copieofficielle:
        "Une copie officielle de ton relevé de notes final et une attestation de réussite (le cas échéant) doivent être soumises pour chaque établissement fréquenté, à l’exception de l’Université du Manitoba et de l’Université de Saint-Boniface. Il demeure de ta responsabilité de t’assurer que l’Université de Saint-Boniface reçoit tous les documents en lien avec ta demande d’admission avant la date limite.",
      inscriptionetablissement:
        "Si tu t’inscris à un autre établissement d’enseignement après avoir soumis cette demande d’admission, tu dois en informer immédiatement l’équipe des admissions à l’adresse courriel ",
      sansetablissement:
        "Si tu n’as pas fréquenté un établissement d’enseignement postsecondaire, tu peux passer directement à la prochaine page de la demande d’admission.",
      haveyouappliedusb:
        "As-tu déjà déposé une demande d’admission à l’Université de Saint-Boniface auparavant?*",
      mostrecentyear:
        "En quelle année?* Si tu as postulé plus d’une fois, indique l’année la plus récente.",
      yes: "Oui",
      no: "Non",
      fournistrenseignements:
        "Fournis les renseignements nécessaires sur chaque établissement d’enseignement postsecondaire que tu as fréquenté (y compris l’USB). Indique le plus récent en premier.",
      educationlevel: "Niveau d’études *",
      schoolname: "Nom de l’établissement",
      startdate: "Date de début des études",
      enddate: "Date de fin des études",
      currentdegreestatus: "Statut actuel à l’établissement*",
      graduationdate: "Année d’obtention du diplôme",
      deleteschool: "Supprimer",
      addschool: "AJOUTER UN ÉTABLISSEMENT",
      fournischoolinfo:
        "Fournis les informations suivantes sur l’établissement",
      schoolincanada: "L’établissement est-il au Canada?",
      selectschoolcanada:
        "Sélectionne l’établissement de la liste d’établissements d’enseignement postsecondaire au Canada*",
      selectschooloutsidecanada:
        "Sélectionne l’établissement de la liste d’établissements d’enseignement postsecondaire en dehors du Canada*",
      currentlystudying: "Présentement aux études",
      graduated: "Diplôme obtenu",
      nolongerstudying:
        "Je ne fréquente plus l’établissement et je n’ai pas obtenu le diplôme",
      startmonthyear:
        "Indique le mois et l’année où tu as commencé de fréquenter cet établissement.",
      finishmonthyear:
        "Indique le mois et l’année où tu as terminé ou prévois terminer tes études à cet établissement.",
      month: "Mois*",
      year: "Année*",
      cancelschool: "ANNULER",
      saveschool: "AJOUTER",
      college: "Collège",
      university: "Université",
      cegep: "Cégep",

      //Page 7 Translations - French
      header: "Autodéclaration des notes de 12e année",
      instructionText:
        "Sur cette page, tu peux déclarer tes notes de cours de la 12e année que tu as terminés jusqu’à présent et que tu prévois terminer pendant l’année scolaire actuelle.",
      example: "Par exemple : Français, 40S, 82",
      instructions: [
        "Il est important de déclarer les notes de tous les cours de la 12e année que tu as déjà terminés jusqu’à présent.",
        "Pour les cours que tu suis présentement, tu peux estimer tes notes en fonction des notes obtenues aux cours semblables de la 11e année ou en fonction des résultats obtenus aux tests et aux devoirs du cours en question.",
        "La déclaration de tes notes de 12e année dans le cadre de ta demande d’admission, permet à l’Université de Saint-Boniface d’évaluer ta candidature et de te rendre une réponse plus rapidement. Si, en fonction des renseignements que tu as fournis, tu sembles être admissible au programme que tu as choisi (à l’exception du baccalauréat en sciences infirmières et diplôme en sciences infirmières auxiliaires), tu recevras une offre d’admission conditionnelle.",
        "Si tu choisis de ne pas déclarer tes notes, tu ne recevras pas de réponse à ta demande d’admission avant le début juillet, lorsque nous recevrons ton relevé de notes final.",
      ],
      labels: {
        grade12Courses: "Cours de 12e année",
        classTitle: "Titre du cours",
        gradewithlabel: "Note *(nombre entier de 0 à 100)",
        level: "Niveau",
        grade: "Note",
        deleteClass: "Supprimer",
        addClass: "AJOUTER UN COURS",
        cancelClass: "ANNULER",
        saveClass: "AJOUTER",
        educationlevel: "Niveau d’études",
        currentdegreestatus: "Statut actuel à l’établissement",
      },
      classes: {
        advancedMathematics: "Mathématiques avancées",
        appliedMathematics: "Mathématiques appliquées",
        canadianLaw: "Droit canadien",
        chemistry: "Chimie",
        cinemaModernHistory: "Cinéma - témoin de l'histoire moderne",
        computerScience: "Informatique",
        currentTopics: "Sujets d'actualité",
        dance: "Danse",
        dramaticArts: "Arts dramatiques",
        english: "Anglais",
        everydayMathematics: "Mathématiques au quotidien",
        familyStudies: "Études de la famille",
        french: "Français (langue première ou immersion)",
        frenchsecond: "Français (langue seconde pour débutant)",
        geography: "Géographie",
        globalIssues: "Enjeux mondiaux",
        guitar: "Guitare",
        harmony: "Harmonie",
        history: "Histoire",
        introCalculus: "Introduction au calcul",
        introCalculusAdvancedMath:
          "Introduction au calcul et mathématiques avancées",
        jazz: "Jazz",
        leadershipTraining: "Entrainement leadership",
        music: "Musique",
        biology: "Biologie",
        philosophy: "Philosophie",
        physicalEducation: "Éducation physique",
        physics: "Physique",
        preCalculusMathematics: "Mathématiques pré-calcul",
        psychology: "Psychologie",
        spanish: "Espagnol",
        textileArtsDesign: "Arts textiles et design",
        visualArts: "Arts visuels",
        workLifeTransition: "Vie-travail : Transition",
        foodNutrition: "Aliments et nutrition",
        other: "Autre",
      },

      // Page 8
      paytheapplicationfee: "Payer les frais de traitement de dossier",
      useacouponcode: "J'ai un code promotionnel / administratif",
      entercouponcode: "Saisir le code",
      applycouponcode: "APPLIQUER LE CODE",
      notavalidcouponcode: "Ce code n'est pas valide",
      couponaccepted: "Code accepté",
      // Page 9
      payapplicationfee: "Payer les frais de traitement de dossier",
      amountdue: "Somme à payer *",
      receiptemail: "Adresse courriel pour l’envoi du reçu *",
      makeapayment: "Payer",
      monerispaymentwasnotsuccessful: "La transaction via Moneris a échoué. Merci d'essayer de nouveau.",
      monerispaymentwasnotsuccessfultext: "Si le problème persiste, écris-nous à l'adresse",
      monerispaymentwassuccessful:
        "La transaction via Moneris a été effectuée avec succès.",
      yourpayment: "Ton paiement de",
      hasbeenreceived:
        "a été reçu. Cliquer sur le bouton « PAGE SUIVANTE » pour accéder à la dernière page de la demande.",

      // Application detail
      myapplication: "Ma demande d’admission",
      creationdate: "Date de création",
      applicationprogram: "Programme",
      yearandterm: "Session",
      submissiondate: "Date de soumission",
      deadline: "Date limite",
      status: "État",
      backpage: "PAGE PRÉCÉDENTE",
      checklist: "Liste de contrôle",
      item: "Élement",
      notes: "Notes",
      duedate: "Date limite pour soumission",
      lastupdated: "Dernière mise à jour",
      myactionneeded: "Mon action requise",
      pending: "En attente",
      underreview: "Vérification en cours",
      received: "Reçu",
      waived: "Non requis",
      uploaddocument: "Téléverser le document",
      seenotes: "Voir la colonne « Notes »",
      none: "Aucune",
      seenotes: "Voir la colonne 'Notes'",
      acceptmyoffer: "ACCEPTER MON OFFRE",
      declinemyoffer: "REFUSER MON OFFRE",
      upload: "TÉLÉVERSER",
      cancel: "ANNULER",
      decisionletters: "Lettres de décision",
      decisionText: "Il se peut que tu aies de la difficulté à accéder à ta lettre à partir de certains appareils mobiles. Pour cette raison, nous te conseillons d'utiliser un ordinateur pour visualiser la lettre.",
      // Application profile
      nonbinary: "Personne non binaire",
      termransgender: "Personne transgenre",
      twospirit: "Personne bispirituelle",
      genderother: "Autre",
    },
    application: {
      applyToday: "Faire une demande d'admission",
      back: "Page précédente",
      save: "Enregistrer",
      next: "Page suivante",
      esignature: "Signature électronique *",
      date: "Date *",
      back: "PAGE PRÉCÉDENTE",
      applynow: "COMMENCER MA DEMANDE D'ADMISSION",
      viewprofile: "VOIR ET MODIFIER MON PROFIL",
      applicationhome: "Admission",
      creationdate: "Date de création",
      program: "Programme",
      yearandterm: "Session ",
      deadline: "Date limite",
      submissiondate: "Date de soumission",
      status: "État",
      statusdescription: "Explication sur l’état",
      submitmyapplication: "SOUMETTRE MA DEMANDE D'ADMISSION",
      otherinfo:
        "Les renseignements recueillis dans la question suivante servent à évaluer les progrès de l’Université de Saint-Boniface vis à vis de son engagement envers le recrutement et la rétention d’étudiants autochtones. La déclaration est volontaire. Elle pourrait également être utilisée pour t’inviter à des évènements ou des activités destinés à la communauté autochtone de l’USB.",
      thanksmsg:
        "Merci d'avoir déposé votre demande d'admission auprès de l'Université de Saint-Boniface ! Un membre de l'équipe du Registrariat traitera votre demande sous peu. Un courriel automatique concernant les prochaines étapes vous sera envoyé dans les 5 prochaines minutes à l'adresse courriel fournie dans votre demande d'admission. Si vous ne l'avez pas reçu, veuillez vérifier votre boite pourriel. Autrement, vous pouvez communiquer avec nous à l'adresse",
      personalInformation: {
        personalInformation: "École, niveau et information sur l'étudiant",
        firstName: "Prénom légal",
        genderCode: {
          genderCode: "Code de genre *",
          male: "Homme",
          female: "Femme",
        },
        governmentid: "ID du gouvernement",
        birthDate: "Date de naissance* (jj / mm / aaaa)",
        lastName: "Nom légal",
        middleName: "Autres prénoms légaux",
        ses_applicant: "Identifiant du candidat",
        ses_birthcountry: "Pays de naissance",
        ses_nationality: "Citoyenneté*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "Programmes*",
        },
      },
      statusOptions: {
        started: "Commencée",
        submitted: "Soumise",
        actionrequired: "Action requise",
        ongoingevaluation: "Évaluation en cours",
        conditionaloffer: "Admission conditionnelle",
        officialacceptance: "Admission officielle",
        rejected: "Refusée",
        inactive: "Inactive",
        offeraccepted: "Offre acceptée",
        prematriculant:"Dossier prêt pour l'inscription",
        noShow:"Admis sans inscription",
        matriculant: "Inscrit",
        student: "Étudiant",
        cancelled: "Annulée",
        waitlisted: "Liste d'attente",
      },
      conatactInformation: {
        conatactInformation: "Coordonnées",
        general: {
          general: "Général",
          emailaddress1: "Adresse courriel",
          emailaddress2: "Autre adresse courriel",
          mobilephone: {
            errorMessage:
              "Le numéro de téléphone cellulaire ne peut pas être vide.",
          },
        },
        homeAddress: {
          homeAddress: "Adresse du domicile",
          address1_city: {
            address1_city: "Ville",
            errorMessage: "La ville ne peut pas être vide",
          },
          address1_country: {
            address1_country: "Pays *",
            errorMessage: "Le pays ne peut pas être vide",
          },
          address1_line1: {
            address1_line1: "Adresse postale",
            errorMessage: "L'adresse postale ne peut pas être vide",
          },
          address1_postalcode: "Code postal",
        },
        legal: {
          legal: "Information sur le tuteur légal",
          gurd_firstname: {
            gurd_firstname: "Prénom",
            errorMessage: "Le prénom ne peut pas être vide",
          },
          gurd_middlename: "Autre prénom",
          gurd_lastname: {
            gurd_lastname: "Nom de famille",
            errorMessage: "Le nom de famille ne peut pas être vide",
          },
          gurd_birthdate: "Date de naissance* (jj / mm / aaaa)",
          gurd_ses_nationality: "Citoyenneté",

          gurd_address1_line1: {
            gurd_address1_line1: "Rue",
            errorMessage: "La Rue ne peut pas être vide",
          },
          gurd_address1_city: {
            gurd_address1_city: "Ville",
            errorMessage: "La ville ne peut pas être vide",
          },
          gurd_address1_country: {
            gurd_address1_country: "Pays *",
            errorMessage: "Le pays ne peut pas être vide",
          },
          gurd_address1_postalcode: "Code postal",
          gurd_emailaddress1: {
            gurd_emailaddress1: "Adresse courriel",
            errorMessage: "L'adresse courriel ne peut pas être vide",
          },
          ses_relationship: {
            ses_relationship: "Relation avec le tuteur légal",
            father: "Père",
            mother: "Mère",
            guardian: "Tuteur",
          },

          gurd_mobilephone: {
            errorMessage:
              "Le numéro de téléphone cellulaire ne peut pas être vide",
          },
        },
        workAddress: {
          workAddress: "Adresse au travail",
          address2_line1: "Adresse postale",
          address2_city: "Ville",
          address2_country: "Pays *",
          address1_postalcode: "Code postal",
        },
        mobilePhone: "Téléphone cellulaire",
        homePhone: "Téléphone à domicile",
        skypeId: "Identifiant Skype",
      },
      education: {
        education: "Information sur les études de premier cycle",
        undergraduate: {
          undergraduate: "École secondaire",
          errorMessage: "L'école secondaire ne peut pas être vide",
          ses_country: "Pays*",
          ses_graduationyear: "Année d'obtention du diplôme*",
          ses_schoolcontact: {
            ses_schoolcontact: "Faculté",
            errorMessage: "La faculté ne peut pas être vide",
          },
          ses_track_value: "Majeure*",
          ses_certificateearned: "Autre certificat",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "Université",
              errorMessage: "L'école secondaire ne peut pas être vide",
            },
            ses_country: "Pays*",
            ses_graduationyear: "Année d'obtention du diplôme*",
            ses_schoolcontact: {
              ses_schoolcontact: "Faculté",
              errorMessage: "La faculté ne peut pas être vide",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "Nom de l'entreprise",
              errorMessage: "Le nom de l'entreprise ne peut pas être vide",
            },
            ses_previousemployment: {
              ses_previousemployment: "Titre du poste",
              errorMessage: "Le titre du poste ne peut pas être vide",
            },
            ses_startdate: "Date d'embauche* (JJ / MM / AAAA)",
          },
        },
      },
      miscellanous: {
        miscellanous: "Information supplémentaire.",
        contactMode: "Méthode de contact préférée",
      },
      emergenencyContact: {
        emergenencyContact: "Contact d'urgence",
        name: "Nom",
        relationship: "Relation",
        phone: "Téléphone du contact d’urgence",
      },
      document: {
        heading: "Documents de la demande d’admission",
        title1: "Type de document",
        title2: "Nom de fichier du document téléchargé",
        types: {
          passport: "Passeport",
          transcript: "Relevé de notes",
          photo: "Photo",
          assessment: "Évaluation",
          financials: "Finances",
          any: "Tous",
        },
      },
    },
    enquiry: {
      save: "Enregistrer",
      clear: "Effacer",
      testData: "Données de test",
      requestInfo: "Demande d'information",
      description: `Faites-nous part de vos  questions ou commentaires en remplissant et en soumettrant le formulaire suivant.`,
      general: {
        general: "Général",
        email: "Courriel",
        password: "Mot de passe",
        confirmPassword: "Confirmez le mot de passe",
      },
      conatactInformation: {
        conatactInformation: "Coordonnées",
        salutation: "Salutation",
        firstName: "Prénom",
        middleName: "Autre prénom",
        lastName: "Nom de famille",
        birthdate: "Date de naissance",
        mobilePhone: "Téléphone cellulaire",
        telephone1: "Téléphone",
        contactMode: {
          any: "Tous",
          email: "Courriel",
          phone: "Téléphone",
          fax: "Télécopieur",
          mail: "Courriel",
        },
        comments: "Saisissez des commentaires",
      },
      homeAddress: {
        homeAddress: "Adresse du domicile",
        address2_country: "Pays *",
        address2_line1: "Rue",
        address2_city: "Ville",
        address2_stateorprovince: "État ou province",
        address2_postalcode: "Adresse code postal",
      },
      mailingAddress: {
        mailingAddress: "Adresse postale (si différente)",
        address2_country: "Pays *",
        address2_line1: "Rue",
        address2_city: "Ville",
        address2_stateorprovince: "État ou province",
        address2_postalcode: "Adresse code postal",
      },
    },
    students: {
      classes: {
        classes: "Mes cours",
        refresh: "Rafraîchir",
        table: {
          classId: "Identifiant de cours",
          class: "Cours",
          course: "Cote de cours",
          classSection: "Section de cours",
          credits: "Crédits",
          classStatus: "Statut du cours",
          status: "Statut",
          attendance: "Présences",
          gradingOption: "Option d'évaluation",
          allTerms: "Toutes les sessions",
          term: "Session",
          schedule: "Mon horaire",
          room: "Salle",
          rooms: "Salle",
          warningcorequisitemsg:
            "Si vous abandonnez ce cours, vous abandonnerez également les cours concomitants qui y sont liés. Voulez-vous continuer?",
          warningmsg:
            "Vous êtes sur le point d'abandonner ce cours. Si vous confirmez cette action, elle ne pourra pas être annulée. Voulez-vous continuer?",
          continue: "Continuer",
          cancel: "Annuler",
          action: "Action",
        },
        attendance: {
          attendance: "Présences",
          classDate: "Dates du cours",
          notes: "Notes",
        },
      },
      selectClasses: {
        selectClasses: "Sélectionnez les cours",
        addNew: "Ajouter nouveau",
        back: "Page précédente",
        submit: "Soumettre",
        description: "Description",
        errorMessageContent: "Vous êtes déjà inscrit à une section du cours",
        errorMessageHeader:
          "Voici les résultats de la vérification des cours que vous avez choisis. Si certains cours posent problème, veuillez revoir vos choix avant de les resoumettre.",
        checkoutDescription: `Veuillez revoir votre sélection de cours. Cliquez sur le bouton Soumettre pour enregistrer vos sélections de cours. Même si le statut du cours est "Disponible", votre inscription sera seulement confirmée si vous répondez à toutes les exigences du cours (préalables, etc.). Si le statut du cours est "Liste d'attente", vous serez ajouté à la liste d'attente du cours.`,
        next: "Suivant",
        total: "Total",
        table: {
          term: "Session",
          code: "Code",
          course: "Cours",
          description: "Description",
          classStatus: "Statut du cours",
          credits: "Crédits",
          gradeOption: "Option de notation",
          classNotes: "Commentaires",
          price: "Prix",
          action: "Action",
          corequisitemsg: "est concomitant de",
          warningtimeconflict: "est en conflit avec un cours auquel vous êtes déjà inscrit(e).",
          multipleTimeConflict: "Il y a un conflit d'horaire entre",
          notenrolled: "Vous n'avez pas été inscrit à ce cours.",
          enrolled: "Vous avez été inscrit à ce cours.",
          and: "et",
          message: "Cette classe figure déjà sur la liste. Veuillez la supprimer avant d'en ajouter une autre.",
        },
        modalTable: {
          courseCatalog: "Catalogue de cours",
          term: "Session",
          allTerms: "Toutes les sessions",
          allSchools: "Écoles",
          department: "Département",
          allDepartments: "Tous les départements",
          course: "Cours",
          allCourses: "Tous les cours",
          campus: "Campus",
          allCampuses: "Tous les campus",
          schedule: "Emploi du temps",
          firstClassMeeting: "Premier cours",
          classNotes: "Commentaires",
          classStatus: "Statut du cours",
          faculty: "Faculté",
          credits: "Crédits",
          enrolled: "Inscriptions / Capacité",
          firstMeet: "Premier cours",
          price: "Prix",
          actions: "Actions",
          close: "Fermer",
          add: "Ajouter",
          classDates: "Dates du cours",
          classDate: "Date du cours",
          endDate: "Date de fin",
          startDate: "Date de début",
          class: "Classe",
          schoolname: "École",
          availableclasses: "Cours disponibles",
          room: "Salle",
        },
      },
      profile: {
        save: "Enregistrer",
        refresh: "Actualiser",
        back: "Page précédente",
        heading: "Mon profil",
        info: `Tout champ avec un * est requis avant que le bouton "Enregistrer" devienne actif.`,
        primaryDetails: {
          primaryDetails: "Renseignements personnels",
          emailaddress1: "Adresse courriel",
          firstName: "Prénom légal",
          preferredname:"Prénom choisi",
          middleName: "Autres prénoms légaux",
          lastName: "Nom légal",
          suffix: "Suffixe",
          gender: "Genre",
          studentid: "N° étudiant",
          usb_univofmanitobastudentid:"N° étudiant de l'Université du Manitoba",
          applicantId: "Identifiant du candidat",
          birthdate: "Date de naissance",
          governmentid: "Numéro d'assurance sociale (NAS)",
          genderCode: {
            male: "Homme",
            female: "Femme",
          },
        },
        contact: {
          contact: "Coordonnées",
          mobilePhone: "Téléphone cellulaire",
          telephone1: "Téléphone",
          telephone2: "Téléphone à domicile",
          business2: "Téléphone au travail",
          prospectivetelephone1: "Téléphone à domicile",
          skypeId: "Identifiant Skype",
          optinfortextmessages:
            "J'accepte de recevoir des messages transactionnels et promotionnels de l'Université par SMS (au numéro indiqué ci-dessus).",
        },
        HomeAddress: {
          HomeAddress: "Adresse actuelle",
          address1_country: "Pays *",
          address1_line1: "Rue",
          address1_city: "Ville",
          address1_stateorprovince: "Province ou état",
          address1_postalcode: "Adresse code postal",
          prospective_address1_postalcode: "Code Postal",
        },
        mailingAddress: {
          mailingAddress: "Adresse postale (si différente)",
          address2_country: "Pays *",
          address2_line1: "Rue",
          address2_city: "Ville",
          address2_stateorprovince: "État ou province",
          address2_postalcode: "Adresse code postal",
        },
        billingAddress: {
          billingAddress:
            "Adresse de facturation (si différente de l'adresse postale)",
          address3_country: "Pays *",
          address3_line1: "Rue",
          address3_city: "Ville",
          address3_stateorprovince: "État ou province",
          address3_postalcode: "Adresse code postal",
        },

        emergenencyContact: {
          emergenencyContact: "Contact d’urgence",
          name: "Nom",
          relationship: "Relation",
          phone: "Téléphone de contact d'urgence",
        },
      },
      degreePlan: {
        canviewegreeplan:
          "Votre rapport de cheminement ne peut pas être affiché en ce moment. Veuillez noter que les rapports de cheminement des programmes universitaires sont en cours d'élaboration et seront affichés ici en 2025.",
        requireddegreecourses: "Cours requis",
        degreecoursegroups: "Autres cours",
        myDegreePlan: "Mon rapport de cheminement",
        programDescription: "Description du programme",
        grade: "Note",
        status: "Statut",
        creditsearned: "Crédits obtenus",
        creditstype: "Type de crédits",
        creditsavailable: "Crédits tentés",
        order: "Séquence",
        coursename: "Nom de la matière",
        course: "Cours",
        degreePlan: "Programme d'études",
        creditsrequired: "Crédits requis",
        earnedCredits: "Crédits réguliers",
        transferCredits: "Crédits de transfert",
        completed: "Complété",
      },
      grades: {
        grades: "Mes notes finales",
        class: "Classe",
        classId: "Identifiant de cours",
        classstatus: "Statut de classe",
        allterms: "Tous les trimestres",
        gradingoption: "Option de note",
        creditsearned: "Crédits acquis",
        course: "Matière",
        credits: "Crédits",
        status: "Statut",
        grade: "Note",
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "Enregistrer",
        heading: "Saisir les présences",
        selectOne: "Sélectionnez-en un",
        term: "Session",
        className: "Titre du cours",
        NoClassNameMsg:
          "Aucun cours n'est disponible pour la session spécifiée",
        classDates: "Dates des cours",
        noClassDatesMsg:
          "Il n'y a pas de dates de cours disponibles pour la saisie des présences",
        attendancereport: "Rapport de présence",
        studentid: "N° étudiant",
        table: {
          studentName: "Nom de l'étudiant",
          institutionIdNo: "Numéro étudiant",
          present: "Présent",
          tardy: "Retard",
          unexcusedAbsent: "Absence non justifiée",
          excusedAbsent: "Absence justifiée",
          remarks: "Remarques",
        },
      },
      testScore: {
        subject: "Sujet",
      },
      class: {
        gradeoption: "Option de note",
        credits: "Crédits",
        classname: "Nom du cours",
        class: "Cours",
        status: "Statut",
      },
    },
    account: {
      unpaidinvoices: "Factures",
      payments: "Paiements",
      paiddate: "Date de paiement",
      date: "Date",
      type: "Type",
      invoicenumber: "Numéro de facture",
      term: "Session",
      viewreceipt: "Reçu",
      amount: "Montant",
      status: "Statut",
      invoice: "Facture",
      totalamount: "Montant total",
      total: "Solde total dû",
      amountpaid: "Montant payé",
      amountremaining: "Solde",
      viewinvoice: "Voir la facture",
      paymentno: "NO. DE PAIEMENT",
      notes: "Commentaires",
      accountsummary: "Relevé de compte",
    },
    documents: {
      availableuntil: "Unité disponible",
      subject: "Sujet",
      filename: "Nom du fichier",
    },
    courseCataLog: {
      heading: "Catalogue de cours",
    },
    homePage: {
      about: {
        about: "À propos de OneWorldSIS Global University",
        desciption:
          "OneWorld Global University a été fondée pour fournir le programme le plus complet axé sur l'enseignement des principes fondamentaux d'une véritable transformation numérique. Ce système permettra aux étudiants d'aider les organisations à développer et à mettre en œuvre une technologie de transformation numérique qui permettra aux établissements d'atteindre leur efficacité optimale et d'améliorer la vie quotidienne de leurs membres.",
      },
      focus: {
        heading: "Nos valeurs fondamentales",
        collegiality: "Collégialité",
        inclusivity: "Inclusivité",
        excellence: "Excellence",
        innovation: "Innovation",
      },
      gallery: {
        studentProfile: "Profil étudiant",
        classes: "Mes cours",
        admission: "Admission",
      },
      newsLetter: {
        heading:
          "Abonnez-vous à notre bulletin d'information pour les dernières nouvelles",
        subscribe: "S'abonner",
        email: "Votre courriel",
      },
    },
    rows: {
      rowsperpage: "Ligne par page:",
    },
  },
});

export default localizedStrings;
